import React, { useEffect } from 'react';
import styles from './signin.module.css';
import ReactPortal from '../ReactPortal';
import { Button } from '@momentum-ui/react';
import { i18n } from '../../utils/GadgetUtils';

const SignIn = (props) => {
    const { handleMediaLogin, recovered } = props;

    useEffect(()=>{
        /* On failback, login will be triggered if recovered flag if true */
        /* recovered will be true if desktop failsback */
        if(recovered){
            handleMediaLogin(null);
        }
    },[recovered]);

    return (
        <div className={styles.container}>
            <ReactPortal>
                <div className={styles.modal} id='imi-signin-modal'>
                    <div className={styles.title}>{i18n.getMsg('gadget.imi.label.manageSignin')}</div>
                    <div className={styles.subtitle}>{i18n.getMsg('gadget.imi.label.signin')}</div>
                    <Button 
                        className={styles.button} tabIndex="0"
                        id='imi-signin-button'
                        onClick={handleMediaLogin}
                        ariaLabel={i18n.getMsg('gadget.imi.label.signin')}
                        color="blue"
                        size="32"
                        tag="button"
                        type="button">
                            {i18n.getMsg('gadget.imi.operation.signin')}
                        </Button>
                </div>
            </ReactPortal>
        </div>
    )
}
export default SignIn;